import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";
import React from "react";

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    description: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title,
    description,
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ fontSize: "1rem", fontFamily: "montserrat" }}>
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    Cancelar
                </Button>
                <Button onClick={onConfirm}
                    sx={{
                        backgroundColor: " #336B87",
                        "&:hover": {
                            backgroundColor: "rgb(40, 101, 131)", // una variante más oscura opcional para el hover
                        },
                        fontFamily: "montserrat"
                    }}
                    variant="contained" autoFocus>
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
